import Login2024 from './modules/login2024';

$(function () {
    if (!window.Login2024) {
        window.Login2024 = new Login2024();
    }
});
